// react components
import React from 'react'
import axios, {
    CancelTokenSource,
} from 'axios'

// data
import {
    contentTypeModelTypeSite,
    reduxAuthStateSite,
    reduxFormHelpersStateSite,
    reduxModalErrorEventHandlerSite,
    reduxModalStateSite,
} from 'data'

// serializers
import {
    ContentTypeFormTypes,
} from 'serializers/site'

// services
import {
    axiosErrorHandlerSite,
    getApiUrlSiteV2,
    getAxiosHeadersSite,
} from 'services'

// main
export function getFormDetailDataSite({
    axiosCancelToken,
    component,
    contentType,
    dispatch,
    formState,
    helpers,
    noEmpty,
    objectId,
    reduxAuth,
    reduxModalSite,
    setAxiosCancelToken,
    setFormState,
    setHelpers,
    setInitialState,
}: {
    axiosCancelToken: CancelTokenSource | undefined
    component: string
    contentType: contentTypeModelTypeSite
    dispatch: React.Dispatch<any>
    formState: ContentTypeFormTypes | undefined
    helpers: reduxFormHelpersStateSite
    noEmpty: boolean
    objectId: string
    reduxAuth: reduxAuthStateSite
    reduxModalSite: reduxModalStateSite
    setAxiosCancelToken: React.Dispatch<CancelTokenSource | undefined>
    setFormState: React.Dispatch<any>
    setHelpers: React.Dispatch<reduxFormHelpersStateSite>
    setInitialState: () => void
}) {
    try {
        if (!noEmpty) {
            setInitialState()
        }
        if (axiosCancelToken) axiosCancelToken.cancel('axios canceled')
        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        setAxiosCancelToken(source)

        const app = contentType.split('_')[0]
        const model = contentType.split('_')[1]
        const refreshAxiosHeaders = getAxiosHeadersSite(reduxAuth, reduxModalSite, dispatch)

        if (objectId && (objectId !== 'new')) {
            if (!noEmpty) {
                setHelpers({
                    ...helpers,
                    isLoading: true,
                })
            }
            const getUrl = getApiUrlSiteV2(`${app}/form/${model}/detail/${objectId}/`, reduxModalSite) // Keep the last '/' for Safari !!!!!!!
            if (process.env.NODE_ENV === 'development') console.log(getUrl, component)
            axios({
                headers: refreshAxiosHeaders,
                method: 'get',
                url: getUrl,
                cancelToken: source.token,
            })
                .then((response) => {
                    if (process.env.NODE_ENV === 'development') console.log(response)
                    const fieldsToReturn = response.data
                    if (fieldsToReturn.attributions_list?.length > 0) {
                        const attributionsDataArray = response.data.profile?.settings_data_json?.contentTypeSettingsCustom?.[contentType]?.form?.fieldsOptions
                        const attributionsArray: any = []
                        Object.keys(attributionsDataArray).forEach(key => {
                            // Check if the key starts with 'attributions_many_to_many_field_'
                            if (key.startsWith('attributions_many_to_many_field_')) {
                                // Push the value associated with the key into the array
                                attributionsArray.push({
                                    key: key,
                                    attribution_category: attributionsDataArray[key]?.selectUrlParams?.attribution_categories,
                                })
                            }
                        })
                        attributionsArray.map((attribution: any) => {
                            const attributions_list = fieldsToReturn.attributions_list
                            fieldsToReturn[`${attribution.key}`] = attributions_list.filter((obj: any) => obj.attribution_category === attribution.attribution_category)
                        })
                    }
                    setFormState({
                        ...formState,
                        contentTypeSettings: response.data.content_type_settings_json,
                        data: {
                            ...formState?.data,
                            errors: {},
                            fields: response.data,
                        },
                        fieldsForm: response.data.content_type_settings_json.form.fieldsForm,
                        fieldsRequired: response.data.content_type_settings_json.form.fieldsRequired,
                        structure: response.data.content_type_settings_json.form.structure,
                    })
                    setHelpers({
                        ...helpers,
                        init: false,
                        errorStatus: undefined,
                        isLoading: false,
                    })
                    setAxiosCancelToken(undefined)
                })
                .catch((error) => {
                    if (error.response?.status === 403) {
                        setHelpers({
                            ...helpers,
                            errorStatus: error.response.status,
                            isLoading: false,
                        })
                    } else if (error.response?.status === 404 && error.response?.data?.detail) {
                        setHelpers({
                            ...helpers,
                            errorStatus: error.response.status,
                            isLoading: false,
                        })
                    } else {
                        setHelpers({
                            ...helpers,
                            errorStatus: undefined,
                            isLoading: false,
                        })
                        axiosErrorHandlerSite({
                            apiUrl: getUrl,
                            component,
                            dispatch,
                            error,
                            reduxAuth,
                            reduxModalSite,
                            reference: 'getFormDetailDataSite',
                        })
                    }
                })
        } else {
            setInitialState()
        }
    } catch (error) {
        setHelpers({
            ...helpers,
            isLoading: false,
        })
        dispatch(reduxModalErrorEventHandlerSite(
            error,
            component,
            'getFormDetailDataSite',
        ))
    }
}
